import { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";

export const addEmployeeService = (
  employeeDataObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.addemployee, employeeDataObject);
};
export const updateEmployeeStatusService = (
  employeeDataObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.put(
    API_PATH().apis.updateEmployeeStatus,
    employeeDataObject
  );
};
export const updateEmployeeService = (
  employeeDataObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.put(API_PATH().apis.addemployee, employeeDataObject);
};

export const deleteEmployeeService = (
  employeeDataObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.put(API_PATH().apis.deleteEmployee, employeeDataObject);
};

export const removeAdminAssociations = (
  businessunit: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: { businessunit },
  };
  return axiosAuth.get(API_PATH().apis.removeAdminAssociations, config);
};

export const fetchEmployeeService = (
  employeeObject?: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {},
  };
  if (employeeObject?.controller) {
    config.params.page = (employeeObject?.controller?.page || 0) + 1;
    config.params.limit = employeeObject?.controller?.limit;
    config.params.searchText = employeeObject.searchText;
  }
  if (
    employeeObject?.controller?.sortBy &&
    employeeObject?.controller?.sortOrder
  ) {
    config.params.sortBy = employeeObject?.controller?.sortBy;
    config.params.sortOrder = employeeObject?.controller?.sortOrder;
  }
  if (employeeObject?.filter) {
    config.params = { ...config.params, ...employeeObject.filter };
  }
  // if (employeeObject?.filter?.status) {
  //   config.params.status = employeeObject?.filter?.status;
  // }
  return axiosAuth.get(API_PATH().apis.fetchemployee, config);
};
export const getDepartmentsService = (): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {},
  };
  return axiosAuth.get(API_PATH().apis.departments, config);
};
export const createDepartmentService = (
  departmentDataObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.department, departmentDataObject);
};

export const emailLink = (employeeLinkObject: any): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.employeelink, employeeLinkObject);
};
